// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2uj4O","header":"styles_header__3jWp6","description":"styles_description__3ilW7","active":"styles_active__1Zjcb"};